import { TranslateService } from '@ngx-translate/core';
import { List } from 'immutable';
import { ISelectOption } from '../../form-master/components/select-field/select-field.interface';

export const weekdays: List<ISelectOption> = List([
  {
    key: 'DATE.WEEKDAY.SUNDAY',
    value: 0,
  },
  {
    key: 'DATE.WEEKDAY.MONDAY',
    value: 1,
  },
  {
    key: 'DATE.WEEKDAY.TUESDAY',
    value: 2,
  },
  {
    key: 'DATE.WEEKDAY.WEDNESDAY',
    value: 3,
  },
  {
    key: 'DATE.WEEKDAY.THURSDAY',
    value: 4,
  },
  {
    key: 'DATE.WEEKDAY.FRIDAY',
    value: 5,
  },
  {
    key: 'DATE.WEEKDAY.SATURDAY',
    value: 6,
  },
]);

export const weekdaysShort: List<ISelectOption> = List([
  {
    key: 'DATE.WEEKDAY.SHORT.SUNDAY',
    value: 0,
  },
  {
    key: 'DATE.WEEKDAY.SHORT.MONDAY',
    value: 1,
  },
  {
    key: 'DATE.WEEKDAY.SHORT.TUESDAY',
    value: 2,
  },
  {
    key: 'DATE.WEEKDAY.SHORT.WEDNESDAY',
    value: 3,
  },
  {
    key: 'DATE.WEEKDAY.SHORT.THURSDAY',
    value: 4,
  },
  {
    key: 'DATE.WEEKDAY.SHORT.FRIDAY',
    value: 5,
  },
  {
    key: 'DATE.WEEKDAY.SHORT.SATURDAY',
    value: 6,
  },
]);

export function weekdaysLocalized(
  _translateService: TranslateService
): List<ISelectOption> {
  return weekdays.map((weekday) => {
    return {
      key: _translateService.instant(weekday.key),
      value: weekday.value,
    };
  }) as List<ISelectOption>;
}

export function weekdaysShortLocalized(
  _translateService: TranslateService
): List<ISelectOption> {
  return weekdaysShort.map((weekdayShort) => {
    return {
      key: _translateService.instant(weekdayShort.key),
      value: weekdayShort.value,
    };
  }) as List<ISelectOption>;
}
